export const SCHEDULE_ACTION_CREATED = 'created';

export const ENTERPRISE_ENVIRONMENT = 'enterprise';
export const PRODUCTION_ENVIRONMENT = 'production';
export const GAMMA_ENVIRONMENT = 'gamma';
export const BETA_ENVIRONMENT = 'beta';
